import scrollTo from '../common/scrollTo'

const fn = {
  init: () => {
    const holder = document.querySelector('.adoption-form-holder')
    const urlParams = new URLSearchParams(window.location.search)
    const isFinished = window.location.href.indexOf('finished') > -1

    if (holder && (urlParams.get('MultiFormSessionID') || isFinished)) {
      scrollTo(holder)
    }
  },
}

export default {
  can: () => document.body.classList.contains('pagetype-adoptionapplicationpage'),
  run: fn.init,
}
